import { securitySettings as AT } from './AT';
import { securitySettings as CZ } from './CZ';
import { securitySettings as HR } from './HR';
import { securitySettings as HU } from './HU';
import { securitySettings as RO } from './RO';
import { securitySettings as SK } from './SK';
import { securitySettings as RS } from './RS';

export const securitySettingsRetailFeatureMap = {
    AT,
    CZ,
    HR,
    HU,
    RO,
    SK,
    RS,
};
